import { render, staticRenderFns } from "./functionDppmPage.vue?vue&type=template&id=7480b46a&scoped=true&"
import script from "./functionDppmPage.vue?vue&type=script&lang=js&"
export * from "./functionDppmPage.vue?vue&type=script&lang=js&"
import style0 from "./functionDppmPage.vue?vue&type=style&index=0&id=7480b46a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480b46a",
  null
  
)

export default component.exports